import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './config';
import { useTranslation } from '@hooks/useTranslation';

interface I18nProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component for internationalization
 * Handles language direction (RTL/LTR) based on current language
 */
const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const { isRTL, getCurrentLanguage } = useTranslation();
  
  useEffect(() => {
    // Update document direction based on language
    const dir = isRTL() ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = getCurrentLanguage();
    
    // Add RTL class to body if needed
    if (isRTL()) {
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
    }
  }, [isRTL, getCurrentLanguage]);
  
  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  );
};

export default I18nProvider; 